<template>
  <div v-if="has_courses">
    <div class="d-flex flex-start gap align-center bg-spo-blue-grey px-2 py-2 radius-bottom mt-5"
      v-if="!mainStore.parcours_billetterie_mode">

      <v-icon :icon="mainStore.parcours_billetterie_mode ? 'mdi-ticket' : 'mdi-routes'" color="darkblue"
        size="32"></v-icon>
      <div class="text-h5 font-weight-bold">{{ mainStore.parcours_billetterie_mode ? 'Les postes' : 'Les parcours' }}
      </div>
    </div>


    <div v-if="has_groupe_accueil_course">
      <div v-for="[groupName, courses] in list_courses_per_group" :key="groupName">
        <CourseItemsGrouped :courses="courses" :groupName="groupName"></CourseItemsGrouped>
      </div>
    </div>
    <div v-else-if="has_groupe_accueil_course_variant">
      <div v-for="[groupName, courses] in list_courses_per_group_variant" :key="groupName">
        <CourseItemsGroupedVariant :courses="courses" :groupName="groupName"></CourseItemsGroupedVariant>
      </div>
    </div>
    <div v-else>
      <CourseItem :course="course" v-for="course in list_courses.list" :key="course.id"></CourseItem>
    </div>


    <InscriptionGateDialogs />
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import CourseItem from "@/components/Home/Courses/Course_Item.vue";
import CourseItemsGrouped from "@/components/Home/Courses/CourseItemsGrouped.vue";
import CourseItemsGroupedVariant from "@/components/Home/Courses/CourseItemsGroupedVariant.vue";
import InscriptionGateDialogs from "@/components/Home/InscriptionGateDialogs.vue";
export default {
  components: { CourseItem, CourseItemsGrouped, CourseItemsGroupedVariant, InscriptionGateDialogs },
  data() {
    return {

    };
  },
  computed: {
    ...mapStores(useMainStore),
    list_courses() {
      return this.mainStore.module.courses;
    },
    has_courses() {
      return this.list_courses.list && this.list_courses.list.length > 0;
    },
    has_groupe_accueil_course() {
      return this.list_courses.list.some(course => course.metadatas.groupe_accueil);
    },
    has_groupe_accueil_course_variant() {
      return this.list_courses.list.some(course => course.metadatas.groupe_accueil_select_variant);
    },
    list_courses_per_group() {
      if (!this.has_groupe_accueil_course) {
        return [];
      }
      let list_courses_per_group = new Map();
      for (let course of this.list_courses.list) {
        if (course.metadatas.groupe_accueil) {
          if (!list_courses_per_group.has(course.metadatas.groupe_accueil)) {
            list_courses_per_group.set(course.metadatas.groupe_accueil, []);
          }
          list_courses_per_group.get(course.metadatas.groupe_accueil).push(course);
        }
        else {
          if (!list_courses_per_group.has(course.nom)) {
            list_courses_per_group.set(course.nom, []);
          }
          list_courses_per_group.get(course.nom).push(course);
        }
      }

      return list_courses_per_group;
    },

    list_courses_per_group_variant() {
      if (!this.has_groupe_accueil_course_variant) {
        return [];
      }
      let list_courses_per_group = new Map();
      for (let course of this.list_courses.list) {
        if (course.metadatas.groupe_accueil_select_variant) {
          if (!list_courses_per_group.has(course.metadatas.groupe_accueil_select_variant)) {
            list_courses_per_group.set(course.metadatas.groupe_accueil_select_variant, []);
          }
          list_courses_per_group.get(course.metadatas.groupe_accueil_select_variant).push(course);
        }
        else {
          if (!list_courses_per_group.has(course.nom)) {
            list_courses_per_group.set(course.nom, []);
          }
          list_courses_per_group.get(course.nom).push(course);
        }
      }

      return list_courses_per_group;
    },
  },
};
</script>

<style lang="scss" scoped></style>